import i18next from '@/i18next';
export const DATETIME_FORMAT = 'MMMM dd, yyyy hh:mm';
export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';
export const DISPLAY_TIME_FORMAT = 'hh:mm';
export const DATE_WITH_TIME_FORMAT = `${DISPLAY_DATE_FORMAT} ${DISPLAY_TIME_FORMAT}`;
export const TIME_FORMAT = 'hh:mm';
export const DATE_FORMAT_ISO = 'yyyy-MM-dd';
export const PICKER_DISPLAY_FORMAT = 'PPP';
export const TODAY = new Date();
export const DAYS = [
    i18next.t('days.sunday'),
    i18next.t('days.monday'),
    i18next.t('days.tuesday'),
    i18next.t('days.wednesday'),
    i18next.t('days.thursday'),
    i18next.t('days.friday'),
    i18next.t('days.saturday'),
];
export const MONTHS = [
    i18next.t('months.january'),
    i18next.t('months.february'),
    i18next.t('months.march'),
    i18next.t('months.april'),
    i18next.t('months.may'),
    i18next.t('months.june'),
    i18next.t('months.july'),
    i18next.t('months.august'),
    i18next.t('months.september'),
    i18next.t('months.october'),
    i18next.t('months.november'),
    i18next.t('months.december'),
];
